import React from 'react';
import SvgIcon from './SvgIcon';

const Star: React.FC<any> = ({ color, height, width, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    version="1"
    viewBox="0 0 430 430"
    width={width}
    height={height}
    className={className}
  >
    <path
      d="M 332.25647,385.51933 L 217.94322,325.58331 L 103.76342,385.77314 L 125.44132,258.53357 L 32.91382,168.54182 L 160.62472,149.83945 L 217.61942,34.031678 L 274.87122,149.71255 L 402.62329,168.13113 L 310.29602,258.32822 L 332.25647,385.51933 z" // eslint-disable-line
      fill={color}
    />
  </SvgIcon>
);

export default Star;
